if (!customElements.get('ja-trustpilot')) {
  customElements.define('ja-trustpilot', class extends HTMLElement {
    connectedCallback() {
      this.widget = this.querySelector('.trustpilot-widget');
      if (!this.widget) return;

      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.onResize = () => this.load(true);
      this.onReady = () => this.load();
      this.breakpoint.addEventListener('change', this.onResize);

      this.bootstrap = document.querySelector('script[src*="widget.trustpilot.com/bootstrap/"]');
      this.bootstrap?.addEventListener('load', this.onReady, { once: true });
      this.load();
    }

    disconnectedCallback() {
      this.breakpoint?.removeEventListener('change', this.onResize);
      this.bootstrap?.removeEventListener('load', this.onReady);
    }

    load(force = false) {
      if (!this.isConnected || !this.widget) return;
      const height = getComputedStyle(this).height;
      const heightChanged = this.widget.dataset.styleHeight !== height;
      this.widget.dataset.styleHeight = height;

      if (window.Trustpilot?.loadFromElement &&
          (force || heightChanged || !this.widget.querySelector('iframe'))) {
        window.Trustpilot.loadFromElement(this.widget, true);
      }
    }
  });
}

